<template>
  <div class="upload">
    <div class="container pt-3 pt-md-0">
      <email-form></email-form>      
    </div>
  </div>  
</template>
<script>
  import EmailForm from "@/components/EmailForm"   
  export default {
    name: "UploadEmail",
    props: {},
    components: { EmailForm },
    data() {
      return {
      
      }
    },
    mounted () {
      this.$nextTick(() => {
        if (this.uploadedFiles.length < 1)
          this.$router.push({ name: "Search"})
      })
    },
    computed: {
      hebrew () {
        return this.$settings.hebrew;
      },
      uploadedFiles () {
        return this.$store.state.urlList
      }
    
    }
  }
</script>
